import React from "react";

export default function Services() {

    const images = [
        "/images/works/12.jpg",
       
        "/images/works/1222.jpg",
        "/images/works/img3.jpg",
        "/images/works/22.jpg",
        "/images/works/31.png",
        "/images/works/41.png",
    ];

    return (
       <section className="relative md:py-32 py-20 bg-gray-50 dark:bg-slate-900" id="service">
    <div className="container">

        {/* Title */}
        <div className="grid grid-cols-1 pb-10 text-center">
            <h3 className="mb-4 md:text-3xl text-2xl font-semibold text-slate-900 dark:text-slate-100">
                My Work Gallery
            </h3>
            <p className="text-slate-500 dark:text-slate-300 max-w-xl mx-auto text-[15px]">
                A collection of my recent works and projects.
            </p>
        </div>

        {/* Image Gallery */}
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 mt-12">
            {images.map((src, index) => (
                <div
    key={index}
    className="p-3 relative group overflow-hidden rounded-xl shadow-lg bg-white dark:bg-slate-800"
>
    <div className="aspect-square w-full overflow-hidden">
        <img
            src={src}
            alt={`work-${index}`}
            className="w-full h-full object-cover transition duration-500 group-hover:scale-110"
        />
    </div>
</div>

            ))}
        </div>

    </div>
</section>

    );
}
